import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

export default class GetPriceGuide extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1>Get Price Guide</h1>
				<p>This method returns the price statistics of the specified item in BrickLink catalog. <strike>Note that returned price does not include VAT</strike></p>
				<h4>Request</h4>
				<table>
					<tbody>
						<tr>
							<th>Method </th>
							<th>URI </th>
						</tr>
						<tr>
							<td> GET </td>
							<td> {`/items/{type}/{no}/price`} </td>
						</tr>
					</tbody>
				</table>
				<h4>Parameters</h4>
				<table>
					<tbody>
						<tr>
							<th>Parameter Name </th>
							<th>Value </th>
							<th>Optional </th>
							<th>Description </th>
						</tr>
						<tr>
							<td> type </td>
							<td> String </td>
							<td> N </td>
							<td> The type of the item. Acceptable values are:<br/>MINIFIG, PART, SET, BOOK, GEAR, CATALOG, INSTRUCTION, UNSORTED_LOT, ORIGINAL_BOX </td>
						</tr>
						<tr>
							<td> no </td>
							<td> String </td>
							<td> N </td>
							<td> Identification number of the item </td>
						</tr>
						<tr>
							<td> color_id </td>
							<td> Integer </td>
							<td> Y </td>
							<td> The color of the item </td>
						</tr>
						<tr>
							<td> guide_type </td>
							<td> String </td>
							<td> Y </td>
							<td> Indicates that which statistics to be provided. Acceptable values are:<br/>- "sold": Gets the price statistics of "Last 6 Months Sales" <br/>- "stock": Gets the price statistics of "Current Items for Sale" (default)</td>
						</tr>
						<tr>
							<td> new_or_used </td>
							<td> String </td>
							<td> Y </td>
							<td> Indicates the condition of items that are included in the statistics. Acceptable values are:<br/>- "N": new item (default)<br/>- "U": used item </td>
						</tr>
						<tr>
							<td> country_code </td>
							<td> String </td>
							<td> Y </td>
							<td> The result includes only items in stores which are located in specified country. <br/>- If you don't specify both country_code and region, this method retrieves the price information regardless of the store's location </td>
						</tr>
						<tr>
							<td> region </td>
							<td> String </td>
							<td> Y </td>
							<td> The result includes only items in stores which are located in specified region. <br/>- Available values are: asia, africa, north_america, south_america, middle_east, europe, eu, oceania<br/>- If you don't specify both country_code and region, this method retrieves the price information regardless of the store's location </td>
						</tr>
						<tr>
							<td> currency_code </td>
							<td> String </td>
							<td> Y </td>
							<td> This method returns price in the specified currency code<br/>- If you don't specify this value, price is retrieved in the base currency of the user profile's </td>
						</tr>
						<tr>
							<td> vat </td>
							<td> String </td>
							<td> Y </td>
							<td> Indicates that price will include VAT for the items of VAT enabled stores. Available values are:<br/>- "N": Exclude VAT (default)<br/>- "Y": Include VAT<br/>- "O": Include VAT as Norway settings </td>
						</tr>
					</tbody>
				</table>
				<h4>Request body</h4>
				<p>Do not supply a request body with this method.</p>
				<h4>Response</h4>
				<p>If successful, this method returns a <a href="?page=resource-representations-catalog">price guide resource</a> as "data" in the response body.</p>
				<h4>Example</h4>
				<ul>
					<li>GET /items/part/3001old/price
						<ul>
							<li>Retrieves price statistics(currently for sale) of PART #3001old in new condition</li>
						</ul>
					</li>
					<li>GET /items/part/3001old/price?new_or_used=U
						<ul>
							<li>Retrieves price statistics(currently for sale) of PART #3001old in used condition</li>
						</ul>
					</li>
					<li>GET /items/part/3001old/price?guide_type=sold
						<ul>
							<li>Retrieves price statistics(last 6 months sales) of PART #3001old in new condition</li>
						</ul>
					</li>
					<li>GET /items/part/3001old/price?guide_type=sold&amp;country_code=US
						<ul>
							<li>Retrieves price statistics(last 6 months sales) of PART #3001old in new condition that are ordered from stores which are located in US. </li>
						</ul>
					</li>
					<li>GET /items/part/3001old/price?region=asia
						<ul>
							<li>Retrieves price statistics(currently for sale) of PART #3001old in new condition that are currently for sale in stores which are located in Asia.</li>
						</ul>
					</li>
					<li>GET /items/part/3001old/price?currency_code=USD
						<ul>
							<li>Retrieves price statistics(currently for sale in USD) of PART #3001old in new condition</li>
						</ul>
					</li>
				</ul>
			</section>
		);
	}
}